/**
 * Danh sách locale được hỗ trợ — dùng cho UI chọn ngôn ngữ, validate store, và script export/import CSV.
 * Khi thêm ngôn ngữ: thêm mục vào `SUPPORTED_LOCALES` + object cùng `id` trong `locales/messages.json`.
 */
export const DEFAULT_LOCALE_ID = 'vi';

/**
 * `flagSrc` trỏ tới file trong `public/flags/` — SVG để cờ luôn hiện (emoji cờ hay thành chữ trên Windows/font thiếu).
 * Khi thêm locale: thêm `public/flags/{id}.svg` và mục tương ứng dưới đây.
 *
 * @type {{ id: string, nativeName: string, flagSrc: string }[]}
 */
export const SUPPORTED_LOCALES = [
  { id: 'vi', nativeName: 'Tiếng Việt', flagSrc: '/flags/vi.svg' },
  { id: 'en', nativeName: 'English', flagSrc: '/flags/en.svg' },
  { id: 'zh', nativeName: '简体中文', flagSrc: '/flags/zh.svg' },
];

export const SUPPORTED_LOCALE_IDS = new Set(SUPPORTED_LOCALES.map((l) => l.id));

/** @param {unknown} id */
export function isSupportedLocale(id) {
  return typeof id === 'string' && SUPPORTED_LOCALE_IDS.has(id);
}

/** @param {unknown} id */
export function normalizeLocale(id) {
  if (!id || typeof id !== 'string') return DEFAULT_LOCALE_ID;
  return isSupportedLocale(id) ? id : DEFAULT_LOCALE_ID;
}

/** @param {string} id */
export function getLocaleCatalogEntry(id) {
  return SUPPORTED_LOCALES.find((l) => l.id === id) ?? SUPPORTED_LOCALES[0];
}

/**
 * Thẻ BCP-47 cho `Intl` / `toLocaleString` (không phải chuỗi UI).
 * Khi thêm locale: bổ sung mapping tại đây nếu cần ngày giờ đúng vùng; không cần sửa từng trang.
 */
export function getLocaleDateFormatTag(locale) {
  const id = normalizeLocale(locale);
  if (id === 'en') return 'en-US';
  if (id === 'zh') return 'zh-CN';
  return 'vi-VN';
}
